__turbopack_context__.v({
  "column": "InscriptionAttribute-module__i1Y-Qa__column",
  "common": "InscriptionAttribute-module__i1Y-Qa__common",
  "epic": "InscriptionAttribute-module__i1Y-Qa__epic",
  "exotic": "InscriptionAttribute-module__i1Y-Qa__exotic",
  "fullRoot": "InscriptionAttribute-module__i1Y-Qa__fullRoot",
  "key": "InscriptionAttribute-module__i1Y-Qa__key",
  "legendary": "InscriptionAttribute-module__i1Y-Qa__legendary",
  "percent": "InscriptionAttribute-module__i1Y-Qa__percent",
  "rare": "InscriptionAttribute-module__i1Y-Qa__rare",
  "root": "InscriptionAttribute-module__i1Y-Qa__root",
  "uncommon": "InscriptionAttribute-module__i1Y-Qa__uncommon",
  "value": "InscriptionAttribute-module__i1Y-Qa__value",
});
